namespace $ {
	export class $shm_surreal_connection extends $mol_object {

		profile(): $shm_surreal_config_profile_data {
			throw new Error( 'SurrealDB profile is not configured' )
		}

		private client_promise: Promise< any > | null = null

		@ $mol_mem
		client() {
			$mol_wire_solid()
			return $mol_wire_sync( this ).client_async()
		}

		async client_async() {
			if( this.client_promise ) return this.client_promise
			this.client_promise = this.client_make_async()
			try {
				return await this.client_promise
			} catch( error ) {
				this.client_promise = null
				throw error
			}
		}

		private async client_make_async() {
			const profile = this.profile()
			const lib = await this.$.$shm_surreal_sdk.lib_async()
			const client = new lib.Surreal()
			await client.connect( $shm_surreal_config_endpoint( profile.endpoint ) )
			await client.use({ namespace: profile.namespace, database: profile.database })
			if( profile.token ) await client.authenticate( profile.token )
			else if( profile.username ) await client.signin({
				username: profile.username,
				password: profile.password ?? '',
			})
			return client
		}

		async query_async( key: string ) {
			const request = JSON.parse( key ) as $shm_surreal_config_query_request
			const client = await this.client_async()
			return client.query( request.statement, request.bindings ?? {} ).collect()
		}

		async live_async( table: string ) {
			const client = await this.client_async()
			const lib = await this.$.$shm_surreal_sdk.lib_async()
			return client.live( new lib.Table( table ) )
		}

		async close_async() {
			const client = await this.client_promise
			this.client_promise = null
			if( client ) await client.close()
		}
	}
}
